import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useFormikContext } from 'formik';

import { Button, TextButton } from '@xingternal/button';
import {
  useDialogContext,
  usePageContext,
  useEditContext,
} from '@xingternal/pages-common';
import { trackEditSaving } from '@xingternal/pages-tracking';

import styles from './PagesFormField.css';

type PagesFormActionsProps = {
  loading: boolean;
};

const PagesFormActions = ({ loading }: PagesFormActionsProps) => {
  const { submitForm, dirty, isValid } = useFormikContext();
  const { executeWithDialog } = useDialogContext();
  const { pageContext } = usePageContext();
  const { trackingData } = useEditContext();

  const goBackUrl = pageContext.goBackUrl;

  const publishHandler = () => {
    if (!dirty) {
      goBackUrl && goBackUrl();
    } else {
      trackEditSaving({
        focusType: pageContext.focusType,
        itemId: pageContext.pageId,
        module: trackingData?.module,
        part: trackingData?.part,
      });
      submitForm();
    }
  };

  return (
    <div className={styles.actions}>
      <TextButton
        size={'medium'}
        disabled={loading}
        onClick={() => goBackUrl && executeWithDialog(goBackUrl)}
      >
        <FormattedMessage id="EP_DISCARD_CTA" />
      </TextButton>
      <Button
        className={styles.publishButton}
        loading={loading}
        size={'medium'}
        variant={'primary'}
        disabled={!isValid}
        onClick={() => publishHandler()}
        data-testid={'PUBLISH'}
      >
        <FormattedMessage id="EP_PUBLISH_CTA" />
      </Button>
    </div>
  );
};

export default PagesFormActions;
